import QRCode from "react-qr-code";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../../constants/urls";
import useReveal from "../../hooks/useReveal";
import GooglePlayIcon from "../icons/GooglePlayIcon";

export default function CTASection({ isDark }) {
	const ref = useReveal(0);
	const surface = isDark ? "var(--color-night)" : "var(--color-paper)";
	const ink = isDark ? "var(--color-on-night)" : "var(--color-ink)";
	const muted = isDark ? "var(--color-on-night-muted)" : "var(--color-muted)";

	return (
		<section className="py-20 md:py-28" style={{ background: surface }}>
			<div className="container mx-auto px-4 sm:px-6">
				<div
					ref={ref}
					className="reveal grid grid-cols-1 md:grid-cols-[1fr_auto] gap-10 items-center max-w-3xl mx-auto"
					style={{
						border: `var(--rule-fine) solid ${isDark ? "var(--color-night-rule)" : "var(--color-ink)"}`,
						padding: "clamp(1.5rem, 4vw, 3rem)",
					}}
				>
					<div className="text-center md:text-left">
						<h2
							className="font-display font-bold uppercase"
							style={{
								fontSize: "var(--text-display-s)",
								lineHeight: "var(--lh-tight)",
								letterSpacing: "var(--tracking-display)",
								color: ink,
								overflowWrap: "anywhere",
							}}
						>
							Ready to elevate your game?
						</h2>
						<p className="mt-4" style={{ fontSize: "var(--text-lg)", color: muted }}>
							Keep your next match score within reach, then review
							your match history in Racketly.
						</p>
						<div className="mt-6 flex flex-col sm:flex-row gap-3">
							<a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className={`btn-slab lift inline-flex ${isDark ? "btn-slab--accent" : "btn-slab--fill"}`}>
							<svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
								<path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
							</svg>
							Download on App Store
							</a>
							<a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" className={`btn-slab lift inline-flex ${isDark ? "btn-slab--outline-night" : "btn-slab--outline"}`}>
								<GooglePlayIcon />
								Get it on Google Play
							</a>
						</div>
					</div>

					<div className="flex flex-col items-center gap-3 mx-auto">
						<div
							className="p-3"
							style={{
								background: "var(--color-paper)",
								border: `var(--rule-fine) solid ${isDark ? "var(--color-night-rule)" : "var(--color-rule-2)"}`,
							}}
						>
							<QRCode
								value={APP_STORE_URL}
								size={120}
								fgColor="oklch(17% 0.035 215)"
								bgColor="oklch(97% 0.006 200)"
							/>
						</div>
						<p
							className="font-display font-bold uppercase"
							style={{ fontSize: "var(--text-xs)", letterSpacing: "var(--tracking-label)", color: muted }}
						>
							Scan for iOS
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
